import moment from "moment"
import { FORMAT_DATE } from "../../assets/constants/default_params"
import { Tag } from "antd"

export const renderDateByUnix = (dateUnix: number) => {
    return moment.unix(dateUnix).format(FORMAT_DATE)
}

export const renderType = (type: string) => {
    const style: object = { width: 100, textAlign: 'center', marginRight: 0 }
    if (type === 'CONNECTION') return <Tag style={style} color="green">Đấu mới</Tag>
    if (type === 'EXTENSION') return <Tag style={style} color="purple">Gia hạn</Tag>
    return
}
